import { useCallback, useState } from 'react';

export const useCartDialogs = () => {
  // 确认对话框状态
  const [showCartItemDialog, setShowCartItemDialog] = useState(false);
  const [cartItemDialogProps, setCartItemDialogProps] = useState<any>({});

  // 半价弹窗状态（如果需要的话）
  const [showHalfPriceDialog, setShowHalfPriceDialog] = useState(false);

  // 关闭确认对话框
  const closeCartItemDialog = useCallback(() => {
    setShowCartItemDialog(false);
    setCartItemDialogProps({});
  }, []);

  // 显示确认对话框的便捷方法
  const showConfirmDialog = useCallback(
    (props: {
      content: string;
      content2?: string;
      content2TextAlignCenter?: boolean;
      confirmText?: string;
      cancelText?: string;
      onConfirm: () => void;
      onCancel?: () => void;
    }) => {
      setCartItemDialogProps({
        content: props.content,
        content2: props.content2 || '',
        content2TextAlignCenter: props.content2TextAlignCenter || false,
        confirmText: props.confirmText || 'Confirm',
        cancelText: props.cancelText || 'Cancel',
        onConfirm: props.onConfirm,
        onCancel: props.onCancel || closeCartItemDialog,
      });
      setShowCartItemDialog(true);
    },
    [closeCartItemDialog],
  );

  return {
    // 确认对话框
    showCartItemDialog,
    cartItemDialogProps,
    setShowCartItemDialog,
    setCartItemDialogProps,
    closeCartItemDialog,
    showConfirmDialog,

    // 半价弹窗
    showHalfPriceDialog,
    setShowHalfPriceDialog,
  };
};
